import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mn-grid-row" }
const _hoisted_2 = { key: 0 }

import { onMounted, reactive } from 'vue';
import { useAppContext } from '@/app/_tech';
//import '@/lib/date.extensions'
import * as arrays from '@/lib/array.lib'
import { ResourceCalendar } from '@/logic/workspaces/rcalendar';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarComponent',
  props: {
    today: {},
    firstDayOfWeek: {},
    calendar: {}
  },
  setup(__props: any) {

const context = useAppContext();


const props = __props

//props.firstDayOfWeek = 1;

const data: { calendar: Date[][], headers: string[] } = reactive({ calendar: [], headers: [] });


const configuration = { lines: 5, margin: 1 };


onMounted(() => setup());

function setup() {

    function TRACE(object: any) { console.log(object) }

    let today = props.today != null ? props.today! : new Date();

    const weekStartDay = props.firstDayOfWeek != null ? props.firstDayOfWeek! : 1; //'1' is for 'monday'

    const { calendar, headers } = initializeCalendar(today, weekStartDay)

    appendCalendarRow(calendar, configuration.lines)

    insertCalendarRow(calendar, configuration.margin)

    data.calendar = calendar;

    data.headers = headers;

    return data;
}

function shift(delta: number) {

    if (data.calendar.length === 0) console.warn('Calendar shif is zero')

    let delta_abs = Math.abs(delta)

    if (delta < 0) { //delete at the end, insert into start

        insertCalendarRow(data.calendar, delta_abs)

        data.calendar.splice(data.calendar.length - delta_abs, delta_abs)
    }

    if (delta > 0) {

        appendCalendarRow(data.calendar, delta_abs)

        data.calendar.splice(0, delta_abs)
    }
}

function initializeCalendar(today: Date, weekStartDay: number): { calendar: Date[][], headers: string[] } {

    const result: { calendar: Date[][], headers: string[] } = { calendar: [], headers: [] }

    const headers_titles = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

    for (let i = weekStartDay; i < weekStartDay + 7; i++) {

        let index = i;

        if (index >= headers_titles.length) index = i % 7;

        result.headers.push(headers_titles[index])
    }

    const today_week = today.currentWeek(weekStartDay);

    const row: Date[] = []

    for (let i = 0; i < 7; i++) {

        row.push(today_week.start.cloneAndAddDays(i))
    }

    result.calendar.push(row);

    return result;


}

function modifyCalendar(c: Date[][], start:Date, quantity: number, operation: (r: Date[]) => void) {

    

    for (let i = 0; i < quantity; i++) {

        const row: Date[] = [];

        for (let j = 0; j < 7; j++) {

            const buffer = new Date(start.valueOf());

            row.push(buffer.addWeeks(i).addDays(j))
        }

        operation(row);
    }
}

function appendCalendarRow(calendar: Date[][], quantity: number) {

    const lastRow = calendar[calendar.length - 1]
    const lastCell = lastRow[lastRow.length - 1];
    const start = lastCell.cloneAndAddDays(1);

    modifyCalendar(calendar, start, quantity, (r:Date[]) => calendar.push(r));
}

function insertCalendarRow(calendar: Date[][], quantity: number) {
    
    const firstRow = calendar[0]
    const firstCell = firstRow[0];

    const start = firstCell.addWeeks(-quantity);

    modifyCalendar(calendar, start, quantity, (r:Date[]) => arrays.insertStrictly(calendar,r,0))
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (shift(4)))
    }, "+4 Week"),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (shift(1)))
    }, "+1 Week"),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (shift(-1)))
    }, "-1 Week"),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (shift(-4)))
    }, "-4 Week"),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.headers, (h, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "mn-grid-cell",
          key: key
        }, _toDisplayString(h), 1))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.calendar, (r, rowKey) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "mn-grid-row",
        key: rowKey
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r, (d, columnKey) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "mn-grid-cell",
            key: columnKey
          }, [
            (rowKey==0 && columnKey==0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(d.getFullYear()) + "|", 1))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(d.getMonth()+1) + "/" + _toDisplayString(d.getDate()) + " ", 1),
            (props.calendar?.resourceOnDateInHours(d) ?? 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(props.calendar!.resourceOnDateInHours(d).toString()) + "h", 1)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})